module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAUVBMVEVHcEwTKTgUKzkUKjoTKjoQIEAUKjkUKzkUKTkQKDgUKDgTKjkTKjgVKTkVKjkUKjoQMEAUKjgUKzkTKjkUKToVKjgUKTkTKTkTKzkUKjkUKjn122g6AAAAGnRSTlMAoI/PnxDPv78gQJCfkN9/EIDP78/fj5Dv74iQw9wAAACDSURBVBgZBcGHYYRAEAQwAQe7x+d3nv4LtQTO73uyjQnY1+QYo5J1h33LmDCXbDvWvABeWZkZUA1LTtdMqIaZm3eDavC+y6C7f/+6myUyqKqPj6piia8DVIM6XDKhGmaGMwOq4ZrJJQ+AR254HhkT5jWfOzwvSY+xJbcdMJcjuf+c8A+SrAbzY0gdYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Vector.png
// module id = 422
// module chunks = 25